import { render, staticRenderFns } from "./PrintPosCocoTeams.vue?vue&type=template&id=582a2024"
import script from "./PrintPosCocoTeams.vue?vue&type=script&lang=js"
export * from "./PrintPosCocoTeams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports